<template>
  <div class="wrap">
    <div style="position: fixed;top: 0;right: 0;left: 0;z-index: 1" class="mint-header">
      <h1 class="mint-header-title" v-show="!len">操作日志</h1>
      <div class="mint-header-title" v-show="len">已选择{{len}}文件</div>
      <router-link to="/more/setinfo" v-if="isreally" style="position: absolute;">
        <span class="back"></span>
      </router-link>
      <div @click="choose()" v-else style="font-size: .28rem;line-height: 1.2rem;position: absolute"
           v-show="isChoose">
        {{isChooseAll ? '取消全选' : '全选'}}
      </div>
      <div slot="right" @click="really()" v-else style="font-size: .28rem;line-height: 1.2rem;text-align: left">
        确定
      </div>
      <div slot="right" @click="open()" v-if="iscancel">
        <i class="iconfont icon-xuanze" style="font-size: .36rem;line-height: 1.2rem;"></i>
      </div>
      <div slot="right" @click="cancel()" v-else style="font-size: .28rem;line-height: 1.2rem;">
        取消
      </div>
    </div>
    <div v-if="list.length===0" class="jpg">
      <div>
        <img src="../../assets/images/null.png" alt="">
        <p>您还没有任何操作～</p>
      </div>
    </div>
    <ul class="main_in" ref="ulBox" v-else
        infinite-scroll-distance="20" infinite-scroll-immediate-check="false"
        v-infinite-scroll="loadMore" infinite-scroll-disabled="moreLoading" id="mainlist">
      <li v-for="(item,index) in list">
        <div class="div">
          <div class="left" style="display: inline-block;">
            <em :fileId="item.id" class="checkbox" :class="{'checked': item.ischeck, 'nochecked': !item.ischeck}"
                v-show="isshow"
                @click.stop="check(item)" ref="checks"></em>
          </div>
          <div class="right" style="display: inline-block;width:88%;">
            <p>{{item.content}}</p>
            <span class="time">{{item.gmtCreate}}</span>
          </div>
          <div id="more" @click="toggleUp(index)" v-bind:class="{'up': isup===index}"></div>
        </div>
        <div class="select" v-if="select===index">
          <ul @click="itemDelete(item)" :fileId="item.id" ref="ul">
            <i class="iconfont icon-lajitong" style=" font-size: 22px; color: #999"></i>
            <p>删除</p>
          </ul>
        </div>
      </li>
    </ul>
    <div class="meauList">
      <button class="button" @click="one_delete()" v-if="ischange">一键清空</button>
      <ul @click="sheetVisibles()" v-else :class="{'selected': isA, 'selected-t': opacity}">
        <i class="iconfont icon-lajitong" style=" font-size: 22px;"></i>
        <p>删除</p>
      </ul>
    </div>
    <!--选中时删除-->
    <mt-actionsheet
      :actions="actions"
      v-model="sheetVisible"
      class="del">
    </mt-actionsheet>
    <!--不用选中时的删除-->
    <mt-actionsheet
      :actions="action"
      v-model="sheetVisibla"
      class="del">
    </mt-actionsheet>
  </div>
</template>
<script>
  import apis from '../../apis/index'
  import cloudApi from '../../apis/cloudStorageApi'
  import { formaTime } from '../../assets/js/tools'
  import { MessageBox, Toast } from 'mint-ui'

  export default {
    data () {
      return {
        info: {
          page: 0,
          size: 20
        },
        moreLoading: false,
        allLoaded: false,
        isChoose: true,
        len: 0,
        page: 0,
        size: 20,
        list: [],
        ids: [],
        isshow: false,
        iscancel: true,
        isreally: true,
        isup: false,
        isChooseAll: false,
        islen: true,
        select: '',
        ischange: true,
        isA: true,
        opacity: false,
        totalElements: 0,
        totalPages: 0,
        actions: [{
          name: '删除',
          method: this.deleted
        }],
        sheetVisible: false,
        action: [{
          name: '删除',
          method: this.deleteone
        }],
        sheetVisibla: false,
        fileId: '',
        delArr: []
      }
    },
    components: {
      formaTime,
      MessageBox,
      Toast
    },
    computed: {
      params () {
        return {
          size: this.size
        }
      }
    },
    created () {
      this.load()
      // this.actionTypes()
    },
    methods: {
      load () {
        let _this = this
        apis.request(cloudApi.log, _this.info).then(function (response) {
          var data = response.data.content
          if (data.length > 0) {
            for (var i = 0; i < data.length; i++) {
              _this.totalElements = response.data.totalElements
              _this.totalPages = response.data.totalPages
              data[i].gmtCreate = formaTime(data[i].gmtCreate)
              _this.list.push(data[i])
            }
          } else {
            _this.list = []
          }
          return false
        })
      },
//      scroll: function () {
//        let sw = true
//        let _this = this
//       _this.page = 1
//        let ulBox = _this.$refs.ulBox
//        if (ulBox.scrollTop + ulBox.clientHeight >= ulBox.scrollHeight) {
//          if (sw === true) {
//            sw = false
//            _this.page++
//            apis.request(cloudApi.log, {page: _this.page, size: _this.size}).then(function (res) {
//              let data = res.data.content
//              if (data.length > 0) {
//                for (let i = 0; i < data.length; i++) {
//                  if (data[i].fileName.length > _this.maxLen) {
//                    data[i].fileName = data[i].fileName.substring(0, _this.maxLen) + '...'
//                  }
//                  data[i].gmtCreate = formaTime(data[i].gmtCreate)
//                  _this.list.push(data[i])
//                }
//              }
//            }).catch(function (error) {
//            })
//            sw = true
//          }
//        }
//      },
      loadMore () {
        this.loading = true
        const content = document.getElementById('mainlist')
        if (content.scrollHeight - content.scrollTop - content.offsetHeight < 10) {
          if (this.totalElements > this.list.length) {
            setTimeout(() => {
              let _this = this
              if (_this.page < _this.totalPages) {
                _this.page++
              }
              apis.request(cloudApi.log, {page: _this.page, size: _this.size}).then(function (res) {
                let list0 = []
                let data = res.data.content
                if (data.length > 0) {
                  for (var i = 0; i < data.length; i++) {
                    list0.push(data[i])
                    data[i].gmtCreate = formaTime(data[i].gmtCreate)
                  }
                  if (_this.list && list0) {
                    _this.list = _this.list.concat(list0)
                  }
                }
              })
              this.loading = false
            }, 250)
          }
        }
      },
// 全选或者取消选择
      choose () {
        if (this.isChooseAll) {
          this.cancelChooseAll()
        } else {
          this.checkAll()
        }
      },
      checkAll () {
        // 全选
        let _this = this
        _this.len = _this.list.length
        console.log(_this.len)
        _this.isChooseAll = true
        if (_this.list.length > 0) {
          _this.list.forEach((row, index, array) => {
            row.ischeck = true
          })
          _this.islen = false
          _this.isA = false
          _this.opacity = true
        }
      },
      cancelChooseAll () {
        this.len = 0
        this.isChooseAll = false
        this.isA = true
        this.opacity = false
        this.list.forEach((row, index, array) => {
          row.ischeck = false
        })
        this.islen = true
      },
      check (item) {
        let _this = this
        if (item.ischeck === undefined) {
          this.$set(item, 'ischeck', true)
          _this.isA = false
          _this.opacity = true
          _this.len++
          return
        }
        if (item.ischeck) {
          item.ischeck = false
          _this.len--
          _this.islen = false
          if (_this.len === 0) {
            _this.isA = true
            _this.opacity = false
          } else {
            _this.isA = false
            _this.opacity = true
          }
        } else {
          _this.isA = false
          _this.opacity = true
          item.ischeck = true
          _this.len++
          _this.islen = true
        }
      },
      open: function () {
        var _this = this
        if (_this.list.length !== 0) {
          _this.isshow = true
          _this.isreally = false
          _this.iscancel = false
          _this.ischange = false
          _this.isA = true
          _this.opacity = false
        }
      },
      cancel: function () {
        var _this = this
        _this.isshow = false
        _this.iscancel = true
        _this.isreally = true
        _this.islen = true
        _this.ischange = true
        _this.isChoose = true
        _this.cancelChooseAll()
      },
      toggleUp: function (index) {
        if (this.select === index) {
          this.select = ''
          this.isup = ''
        } else {
          this.select = index
          this.isup = index
        }
      },
      deleted () {
        let _this = this
        _this.list.forEach((value) => {
          if (value.ischeck) {
            _this.ids.push(value.id)
          }
        })
        apis.request(cloudApi.logDeteleted, {logIds: _this.ids.join(',')}).then(() => {
          Toast({
            message: '删除成功',
            iconClass: 'icon-success'
          })
          _this.load()
          _this.index = '操作日志'
          _this.iscancel = true
          _this.ischange = true
          _this.isreally = true
          _this.isshow = false
          _this.restore()
        }).catch(function (error) {
          Toast({
            message: error.response.data.message,
            iconClass: 'icon-error'
          })
        })
      },
      deleteone () {
        var _this = this
        apis.request(cloudApi.logDeteleted, {logIds: this.fileId}).then(() => {
          Toast({
            message: '删除成功',
            iconClass: 'icon-success'
          })
          _this.load()
          _this.restore()
        }).catch((error) => {
          Toast({
            message: error.response.data.error,
            iconClass: 'icon-error'
          })
          _this.select = ''
        })
      },
      itemDelete (item) {
        this.fileId = item.id
        this.sheetVisibla = true
        this.sheetVisible = false
      },
      sheetVisibles () {
        if (this.list.length > 0) {
          this.list.forEach((rows) => {
            console.log(rows.ischeck)
            if (rows.ischeck) {
              this.sheetVisibla = false
              this.sheetVisible = true
            }
          })
        }
      },
      one_delete () {
        var _this = this
        if (this.list.length > 0) {
          MessageBox.confirm('删除', {
            message: '<div style="margin-bottom: 10px">日志删除</div>' +
            '<p style="font-size: .28rem;color: #9b9b9b">确定要删除吗？</p>' +
            '<p style="font-size: .28rem;color: #9b9b9b">删除后将无法恢复</p>',
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
            center: true
          }).then(() => {
            apis.request(cloudApi.logsDeteleted).then(function () {
              Toast({
                message: '删除成功',
                iconClass: 'icon-success'
              })
              _this.load()
            }).catch((error) => {
              Toast({
                message: error.response.data.message,
                iconClass: 'icon-error'
              })
            })
          })
        } else {
          return false
        }
      },
      restore: function () {
        this.page = 0
        this.size = 20
        this.list = []
        this.isshow = false
        this.iscancel = true
        this.isreally = true
        this.isup = false
        this.islen = true
        this.select = ''
        this.up = ''
        this.ischange = true
        this.isA = true
        this.opacity = false
        this.sheetVisible = false
        this.sheetVisibla = false
        this.isChooseAll = false
        this.len = 0
        this.fileId = ''
        this.delArr = []
        this.info = {
          page: 0,
          size: 20
        }
      }
    }
  }
</script>
<style scoped>
  body {
    font-size: 0.16rem !important;
  }

  .wrap {
    /*padding-top: 1rem;*/
    height: 100%;
    /*padding-bottom: 1rem;*/
    /*position: relative;*/
    background-color: #F7F7FA;
  }

  .main_in {
    /*height: 100%;*/
    width: 100%;
    overflow-y: scroll;
    position: absolute;
    top: 1.44rem;
    bottom: 1rem;
    background-color: #fff;
    border-top: 1px solid #e5e5e5;
  }

  .main_in li p {
    font-size: .28rem;
    color: #1d1f22;
    word-wrap: break-word;
    margin-bottom: .08rem;
  }

  .main_in li .div {
    /*height: .98rem;*/
    overflow: hidden;
    position: relative;
    border-bottom: 1px solid #e5e5e5;
    padding: .2rem .3rem;
  }

  .main_in li span {
    color: #9b9b9b;
    font-size: .24rem;
  }

  .main_in li .time {
    margin-bottom: .2rem;
  }

  .back {
    width: .2rem;
    height: .3rem;
    background: url("../../assets/images/back.png") no-repeat;
    background-size: .2rem .31rem;
    float: left;
    margin-top: .1rem;
  }

  .checkbox {
    width: 0.24rem;
    height: 0.24rem;
    display: inline-block;
    border-radius: 50%;
    border: 0.01rem solid #979797;
    /*float: left;*/
    margin-right: .36rem;
    margin-bottom: 0.32rem;
  }

  .checked {
    background: url('../../assets/images/success_big.png') center no-repeat;
    background-size: 0.24rem 0.24rem;
    border: none;
  }

  .nochecked {
    border: 0.01rem solid #979797;
  }

  #more {
    width: 0.2rem;
    height: 0.26rem;
    position: absolute;
    right: 0.2rem;
    top: 0.4rem;
    background: url("../../assets/images/down.png") center no-repeat;
    background-size: 0.18rem 0.12rem;
  }

  .up {
    background: url("../../assets/images/up.png") center no-repeat !important;
    background-size: 0.18rem 0.12rem !important;
  }

  .select {
    height: .98rem;
    background-color: #f7f7fa;
    text-align: center;
    /*line-height: .98rem;*/
  }

  .select ul {
    /*padding-top: .2rem;*/
    padding: .1rem .3rem .1rem .3rem;
  }

  .select ul p {
    font-size: .2rem;
    color: #333333;;
  }

  .meauList {
    padding: 5px 20px;
    position: fixed;
    bottom: 0;
    width: 100%;
    background: #3f4b5e;
    text-align: center;
  }

  .button {
    width: 100%;
    text-align: center;
    height: .75rem;
    background: #E4393C;
    color: #fff;
    border: 1px solid #E4393C;
    font-size: .36rem;
    border-radius: 8px;
  }

  /*无内容时的样子*/
  .jpg {
    position: relative;
    height: 100%;
  }

  .jpg > div {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
  }

  .jpg div p {
    font-size: 0.28rem;
    color: #41464c;
  }

  .selected {
    background-color: #3f4b5f;
    color: inherit !important;
    font-size: 0.2rem;
  }

  .selected-t {
    color: #ffffff;
  }

  a {
    color: inherit !important;
  }

  .del li {
    color: #ff2424 !important;
  }
</style>
<style lang="scss">
  @import "../../assets/css/variable";
  .mint-header {
    height: 1.28rem !important;
    line-height: .88rem !important;
    background-color: $topbar-background-color !important;
    font-size: .36rem !important;
    padding: 0 .31rem !important;
  }
</style>



// WEBPACK FOOTER //
// src/views/log/log.vue